import {Injectable} from '@angular/core';
import {SearchEntityLevels} from '../../../../../types/nso-data-portal/search-entity-levels';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {LiveCountData, LiveCountTransformedData} from '../../../../../types/nso-data-portal/live-count-data';
import {ScoutDonateRestService} from '../rest/scout-donate-rest.service';
import {environment} from '../../../../../../../environments/environment';

interface LiveCountOptions {
  entityLevel: SearchEntityLevels;
  entityId: number;
  orgName: string;
}

@Injectable({
  providedIn: 'root'
})
export class LiveCountService {

  private readonly EXPLORE_PATH = '/explore';

  constructor(private sdpService: ScoutDonateRestService) {
  }

  getLiveCountData(options: LiveCountOptions): Observable<LiveCountTransformedData> {
    switch (options.entityLevel) {
      case SearchEntityLevels.ORGANIZATION:
        return this.getCountForOrganization(options.orgName);
      case SearchEntityLevels.REGION:
        return this.getCountForRegion(options.entityId);
      case SearchEntityLevels.WORLD:
        return this.getCountForWorld();
    }
  }

  private getCountForOrganization(orgName: string) {
    return this.sdpService.getLiveCount(orgName)
      .pipe(map((result: LiveCountData) => {
          return {
            link: this.constructLink(result.organisations[0].id),
            count: result.count
          };
        })
      )
      .pipe(catchError(() => this.processError()));
  }

  private getCountForRegion(entityId: number) {
    return this.sdpService.getLiveCountForRegion(entityId)
      .pipe(map((result: LiveCountData) => {
          const mappedIds = result.organisations.map(o => o.id).join('","');
          return {
            link: this.constructLink(mappedIds),
            count: result.count
          };
        })
      )
      .pipe(catchError(() => this.processError()));
  }

  private getCountForWorld() {
    return this.sdpService.getLiveCountForWorld()
      .pipe(map((result: LiveCountData) => {
        return {
          link: this.getDefaultLink(),
          count: result.count
        };
      }))
      .pipe(catchError(() => this.processError()));
  }

  private processError() {
    return of({
      link: this.getDefaultLink(),
      count: 0
    });
  }

  private getDefaultLink() {
    return environment.sdpUrl + this.EXPLORE_PATH;
  }

  private constructLink(body) {
    return `${environment.sdpUrl}/explore?nso=%7B"inq":%5B"${body}"%5D%7D`;
  }
}
